import { UserRoutesEnum } from "@utilities/enums";
import { User, UserShopRoleEnum } from "@utilities/types";
import { fetchRequest } from "@utilities/requests";

export const userService = {

    login: async (credentials: { email: string; password: string }) => {
        return await fetchRequest({
            route: UserRoutesEnum.USER_LOGIN,
            method: "POST",
            data: credentials
        });
    },

    create: async (userData: { email: string, role: UserShopRoleEnum, organisationID?: string }) => {
        return await fetchRequest({
            route: UserRoutesEnum.USER_CREATE,
            method: "POST",
            data: userData
        });
    },

    createUserPassword: async (data: { token: string; password: string }) => {
        return await fetchRequest({
            route: UserRoutesEnum.USER_CREATE_USER_PASSWORD,
            method: "POST",
            data: data
        });
    },

    updateUserPassword: async (data: { token: string; oldPassword: string; newPassword: string }) => {
        return await fetchRequest({
            route: UserRoutesEnum.USER_UPDATE_USER_PASSWORD,
            method: "PUT",
            data: data
        });
    },

    updateUser: async (userData: Partial<User>) => {
        return await fetchRequest({
            route: UserRoutesEnum.USER_UPDATE_USER,
            method: "PUT",
            data: userData
        });
    },

    verifyEmail: async (data: { email: string; otpCode: string }) => {
        return await fetchRequest({
            route: UserRoutesEnum.USER_VERIFY_EMAIL,
            method: "POST",
            data: data,
        });
    },
    
    resendOtp: async (token: string) => {
        return await fetchRequest({
            route: UserRoutesEnum.USER_RESEND_OTP,
            method: "POST",
            data: { token },
        });
    },

    getAllCollaborators: async (organisationId: string) => {
        return await fetchRequest({
            route: `${UserRoutesEnum.USER_GET_ALL_BY_ORG_ID}/${organisationId}`,
            method: "GET",
        });
    },

    forgotPassword: async (email: string) => {
        return await fetchRequest({
            route: UserRoutesEnum.USER_FORGOT_PASSWORD,
            method: "POST",
            data: { email }
        });
    },
};
